export const environment = {
  production: false,
  environment: 'desarrollo',
  apiUrl: 'https://dev-2-api.iv.solutions'
};
